export default __webpack_public_path__ + "static/media/WA.d095a7b3.png";